const appConfig = {
  apiPrefix: process.env.REACT_APP_API_URL,
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: process.env.REACT_APP_PORTAL_URL,
  tourPath: "/",
  enableMock: false,
};

export default appConfig;
